import { useState } from 'react';

function useActionState(init) {
    const initialState = Object.assign({ isIdle: true, isLoading: false, isError: false, isSuccess: false, isCompleted: false, errorMsg: undefined, data: undefined }, init);
    const [state, setState] = useState(initialState);
    const updateField = (key, value) => {
        setState((prev) => (Object.assign(Object.assign({}, prev), { [key]: value })));
    };
    return {
        value: state,
        updateValue: setState,
        updateField: updateField,
    };
}

export { useActionState };
//# sourceMappingURL=useActionState.js.map
